import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./loader/loader.component";
import { FormFieldComponent } from "./form-field/form-field.component";
import { TabComponent } from "./tab/tab.component";
import { CardComponent } from "./card/card.component";
import { CardHeaderComponent } from "./card/card-header.component";
import { CardFooterComponent } from "./card/card-footer.component";
import { CardContentComponent } from "./card/card-content.component";
import { ModalComponent } from "./modal/modal.component";
import { AddressInputComponent } from "./address-input/address-input.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AutocompleteFormFilterComponent } from "./autocomplete-form-filter/autocomplete-form-filter.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { ImgFallbackDirective } from "./img-fallback.directive";
import { TableComponent } from "./table/table.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ColumnDefDirective } from "./table/column-def.directive";
import { DisableControlDirective } from "./disable-control.directive";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ImageRotateDirective } from "./image-rotate.directive";
import { RouterModule } from "@angular/router";
import { ToggleButtonComponent } from "./toggle-button/toggle-button.component";
import { ButtonComponent } from "./button/button.component";
import { AutocompleteMultiFormFilterComponent } from "./autocomplete-multi-form-filter/autocomplete-multi-form-filter.component";
import { AppDirectivesModule } from "../directives/app-directives.module";
import { SpinnerComponent } from "./spinner/spinner.component";
import { DatePickerComponent } from "../shared/date-picker/date-picker.component";
import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { LoaderSvgComponent } from "./loader-svg/loader-svg.component";
import { AccountsSearchComponent } from "./accounts-search/accounts-search.component";
import { TooltipComponent } from "./tooltip/tooltip.component";
import { TooltipDirective } from "./tooltip/tooltip.directive";
import { CurrencyPasteNewDirective } from "./currency-paste-new.directive";
import { AutoFocusDirective } from "./autofocus/autofocus.directive";
import { TooltipPurpleComponent } from "./tooltip-purple/tooltip-purple.component";
import { TooltipPurpleDirective } from "./tooltip-purple/tooltip-purple.directive";
import { ClickOutsideDirective } from "./clickaway-directive/clickaway.directive";
import { AutocompleteVendorsComponent } from "./autocomplete-vendors/autocomplete-vendors.component";
import { CheckboxSelectTplComponent } from "./checkbox-select/checkbox-select.component";

@NgModule({
  declarations: [
    LoaderComponent,
    AccountsSearchComponent,
    FormFieldComponent,
    TabComponent,
    CardComponent,
    CardHeaderComponent,
    CardFooterComponent,
    CardContentComponent,
    ModalComponent,
    ToggleButtonComponent,
    ButtonComponent,
    AddressInputComponent,
    AutocompleteFormFilterComponent,
    ClickOutsideDirective,
    AutocompleteMultiFormFilterComponent,
    AutocompleteVendorsComponent,
    ImgFallbackDirective,
    TableComponent,
    ColumnDefDirective,
    DisableControlDirective,
    ImageRotateDirective,
    SpinnerComponent,
    DatePickerComponent,
    LoaderSvgComponent,
    TooltipComponent,
    TooltipDirective,
    TooltipPurpleDirective,
    AutoFocusDirective,
    CurrencyPasteNewDirective,
    TooltipPurpleComponent,
    CheckboxSelectTplComponent,
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
    RouterModule,
    MatTooltipModule,
    AppDirectivesModule,
    FormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
  ],
  exports: [
    LoaderComponent,
    FormFieldComponent,
    TabComponent,
    CardComponent,
    CardHeaderComponent,
    CardFooterComponent,
    CardContentComponent,
    AddressInputComponent,
    AutocompleteFormFilterComponent,
    AutocompleteVendorsComponent,
    AutocompleteMultiFormFilterComponent,
    ImgFallbackDirective,
    TableComponent,
    ColumnDefDirective,
    DisableControlDirective,
    ImageRotateDirective,
    ToggleButtonComponent,
    ButtonComponent,
    SpinnerComponent,
    DatePickerComponent,
    LoaderSvgComponent,
    AccountsSearchComponent,
    TooltipComponent,
    TooltipDirective,
    TooltipPurpleDirective,
    CurrencyPasteNewDirective,
    AutoFocusDirective,
    TooltipPurpleComponent,
    ClickOutsideDirective,
    CheckboxSelectTplComponent,
  ],
})
export class ComponentsModule {}
